export interface IOtherCCData {
  cardType: string;
  code: {
    name: string,
    length: number,
  };
  displayName: string;
  format: RegExp;
  gaps: number;
  image: string,
  pattern: RegExp;
  length: number;
}  

export enum StandardPaymentCardType {
  Visa = 'visa',
  MasterCard = 'mastercard',
  Discover = 'discover',
  AmericanExpress = 'amex',
  Maestro = 'maestro',
  Codensa = 'codensa',
  Diners = 'diners',
  Magna = 'magna',
}

export enum RCPaymentCardType {
  Visa = 'Visa',
  MasterCard = 'MasterCard',
  Discover = 'Discover',
  AmericanExpress = 'American Express',
  Maestro = 'Maestro',
  Codensa = 'Codensa',
  Diners = 'Diners',
  Magna = 'Magna',
}

export const mapStandardToRCCardTypes: Record<StandardPaymentCardType, RCPaymentCardType> = {
  [StandardPaymentCardType.AmericanExpress]: RCPaymentCardType.AmericanExpress,
  [StandardPaymentCardType.Discover]: RCPaymentCardType.Discover,
  [StandardPaymentCardType.Maestro]: RCPaymentCardType.Maestro,
  [StandardPaymentCardType.MasterCard]: RCPaymentCardType.MasterCard,
  [StandardPaymentCardType.Visa]: RCPaymentCardType.Visa,
  [StandardPaymentCardType.Codensa]: RCPaymentCardType.Codensa,
  [StandardPaymentCardType.Diners]: RCPaymentCardType.Diners,
  [StandardPaymentCardType.Magna]: RCPaymentCardType.Magna,
};

export const codensaCC: IOtherCCData = {
  cardType: 'codensa',
  code: {
    length: 3,
    name: 'CVC',
  },
  displayName: 'Codensa',
  format: /^(\d{0,6})(\d{0,6})(\d{0,4})$/,
  gaps: 2,
  image: 'http://img.mlstatic.com/org-img/MP3/API/logos/codensa.gif',
  length: 16,
  pattern: /^(590712|529448)\d{0,10}$/,
};

export const dinersCC: IOtherCCData = {
  cardType: 'diners',
  code: {
    length: 3,
    name: 'CVV',
  },
  displayName: 'Diners',
  format: /^(\d{0,4})(\d{0,6})(\d{0,4})$/,
  gaps: 2,
  image: 'http://img.mlstatic.com/org-img/MP3/API/logos/diners.gif',
  length: 14,
  pattern: /^((30)|(36)|(38)|(39))\d{0,12}$/,
};

export const magnaCC: IOtherCCData = {
  cardType: 'magna',
  code: {
    length: 3,
    name: 'CVC',
  },
  displayName: 'Magna',
  format: /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/,
  gaps: 3,
  image: 'http://img.mlstatic.com/org-img/MP3/API/logos/magna.gif',
  length: 16,
  pattern: /^(5680)\d{0,12}$/,
};

export default RCPaymentCardType;
